jQuery(document).ready(function($){

$("#nav-icon").click(function(){
    $(this).toggleClass('open');
    $('.main-nav-wrapper').toggleClass('open');
});

$(".dropdown-click").click(function(){
	$('.sub-menu').toggle();
});

//Editable fields
/*$('.edit-job .edit').click(function(){
		$(this).hide();
		$(this).prev().hide();
		$(this).next().show();
		$(this).next().select();
	});

$('.edit-job input[type="text"]').blur(function() {
     if ($.trim(this.value) == ''){
		 this.value = (this.defaultValue ? this.defaultValue : '');
	 }
	 else{
		 $(this).prev().prev().html(this.value);
	 }

	 $(this).hide();
	 $(this).prev().show();
	 $(this).prev().prev().show();
      });

  $('.edit-job input[type="text"]').keypress(function(event) {
	  if (event.keyCode == '13') {
		  if ($.trim(this.value) == ''){
			 this.value = (this.defaultValue ? this.defaultValue : '');
		 }
		 else
		 {
			 $(this).prev().prev().html(this.value);
		 }

		 $(this).hide();
		 $(this).prev().show();
		 $(this).prev().prev().show();
	  }
  });

$('.edit-job textarea').blur(function() {
     if ($.trim(this.value) == ''){
		 this.value = (this.defaultValue ? this.defaultValue : '');
	 }
	 else{
		 $(this).prev().prev().html(this.value);
	 }

	 $(this).hide();
	 $(this).prev().show();
	 $(this).prev().prev().show();
      });
*/
  // $('textarea').keypress(function(event) {
	 //  if (event.keyCode == '13') {
		//   if ($.trim(this.value) == ''){
		// 	 this.value = (this.defaultValue ? this.defaultValue : '');
		//  }
		//  else
		//  {
		// 	 $(this).prev().prev().html(this.value);
		//  }

		//  $(this).hide();
		//  $(this).prev().show();
		//  $(this).prev().prev().show();
	 //  }
  // });

  $('#postcode').blur(function() {
		$('#google_maps_variation').html('');
		$.post("/clients/create-job",
			{
				location: $('#postcode').val(), 'do': 'get-latlong'
			}, 
			function(response)
			{
				response_count = response.length;
				console.log(response_count);
				addresses_str = ""; 

				if(response_count == 1)
				{
					latitude = response[0]['latitude'];
					longitude = response[0]['longitude'];

					initialize_maps(latitude, longitude);

					$('#latitude').val(latitude);
					$('#longitude').val(longitude);
				}
				else
				{
					$('#google_maps_variation').html("Could not locate this postcode...Try again");
				}
			}
		);
		return false;
	});
	
	//Bootstrap form validation (CLIENT SIDE) - all forms require the following: <form class="needs-validation" novalidate>
	window.addEventListener('load', function() {
		var forms = document.getElementsByClassName('needs-validation');
		var validation = Array.prototype.filter.call(forms, function(form) {
			form.addEventListener('submit', function(event) {
				if (form.checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();
				}
				form.classList.add('was-validated');
			}, false);
		});
	});
	//second form on the same page
	window.addEventListener('load', function() {
		var forms_pwd = document.getElementsByClassName('needs-validation-password');
		/*console.log(forms_pwd);
		event.preventDefault();
		event.stopPropagation();*/
		var validation_pwd = Array.prototype.filter.call(forms_pwd, function(form_pwd) {
			form_pwd.addEventListener('submit', function(event) {
				if (form_pwd.checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();
				}
				form_pwd.classList.add('was-validated');
			}, false);
		});
	});
	
	//matchheight plugin
	$('.matchheight').matchHeight();
	
	//Bootstrap Carousel
	$('#carouselHiringPg').carousel({
		interval: 3000
	});
});